// web_components/wcTable/wcTable_Renderer.ts

/**
 * Generates the HTML for the wc-table component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        
        <div id="${instanceId}" class="wc-table ${variables.toggleIcons == 'true' ? `wc-table--with-icons` : ''}">
        	<h2>${variables.tableHeading}</h2>
			<div class="table">
			
				<div class="table__header">
					<div>
						${variables.leftColHeadCopy}
					</div>
		
					<div>
						${variables.rightColHeadCopy}
					</div>
        		</div>
			
				${
					variables.leftRow1Copy || variables.rightRow1Copy
						? `
				<div class="table__row">
					<div>
						<p>${variables.leftRow1Copy}</p>
					</div>
				
					<div>
						<p>${variables.rightRow1Copy}</p>
					</div>
				</div>`
						: ''
				}
				
				${
					variables.leftRow2Copy || variables.rightRow2Copy
						? `
				<div class="table__row">
					<div>
						<p>${variables.leftRow2Copy}</p>
					</div>
				
					<div>
						<p>${variables.rightRow2Copy}</p>
					</div>
				</div>`
						: ''
				}
				
				${
					variables.leftRow3Copy || variables.rightRow3Copy
						? `
				<div class="table__row">
					<div>
						<p>${variables.leftRow3Copy}</p>
					</div>
				
					<div>
						<p>${variables.rightRow3Copy}</p>
					</div>
				</div>`
						: ''
				}
				
				${
					variables.leftRow4Copy || variables.rightRow4Copy
						? `
				<div class="table__row">
					<div>
						<p>${variables.leftRow4Copy}</p>
					</div>
				
					<div>
						<p>${variables.rightRow4Copy}</p>
					</div>
				</div>`
						: ''
				}
				
				${
					variables.leftRow5Copy || variables.rightRow5Copy
						? `
				<div class="table__row">
					<div>
						<p>${variables.leftRow5Copy}</p>
					</div>
				
					<div>
						<p>${variables.rightRow5Copy}</p>
					</div>
				</div>`
						: ''
				}
				
			</div>
        </div>
    `;
}
